import Heading from "@/components/tpr/Heading/Heading";
import { BreadcrumbItem, BreadcrumbLink } from "@/components/ui/breadcrumb";
import { useBreadcrumb } from "@/contexts/breadcrumbContext";
import { useEffect } from "react";
// import { Item, ItemActions, ItemContent, ItemDescription, ItemTitle } from "@/components/ui/item";
// import { useMember } from "@/contexts/memberContext";

const BillingView = () => {
  // const { member } = useMember();

  const { setBreadcrumb } = useBreadcrumb();

  useEffect(() => {
    setBreadcrumb(
      <>
        <BreadcrumbItem className="text-sm text-gray-600 truncate max-w-[125px] md:max-w-none">
          <BreadcrumbLink href="#">Billing &amp; Membership</BreadcrumbLink>
        </BreadcrumbItem>
      </>
    );
    return () => setBreadcrumb(null);
  }, [setBreadcrumb]);

  return (
    <div>
      <div className="px-4 min-h-[80vh]">
        <div className="mb-8 mt-8">
          <Heading title={`Billing & Membership`} />
        </div>
        <div className="flex flex-col gap-2">xxx</div>
      </div>
    </div>
  );
};

export default BillingView;
